module.exports = __webpack_public_path__ + "52e1209f06e4fab1170a538562b8bd09.ttf";